import { render } from "./OverviewAlerts.vue?vue&type=template&id=21fe210e&scoped=true"
import script from "./OverviewAlerts.vue?vue&type=script&lang=js"
export * from "./OverviewAlerts.vue?vue&type=script&lang=js"

import "./OverviewAlerts.vue?vue&type=style&index=0&id=21fe210e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fe210e"]])

export default __exports__